export const isRankChartPrintPreviewPath = (pathname = '') => {
  return pathname.startsWith('/administrator/rank/chart_print_preview');
};

export const shouldRenderAdministratorBanners = (pathname = '') => {
  return pathname.includes('administrator') && !isRankChartPrintPreviewPath(pathname);
};
